"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactNumberFormat = require("react-number-format");
var _reactHookForm = require("react-hook-form");
var _Label = _interopRequireDefault(require("../../structure/Label"));
var _FormHint = _interopRequireDefault(require("../../structure/FormHint"));
var _FormRow = _interopRequireDefault(require("../../structure/FormRow"));
var _useDebounce = _interopRequireDefault(require("../../../hooks/useDebounce"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function PatternNumberInputComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    placeholder = props.placeholder,
    unitLabel = props.unitLabel,
    onChange = props.onChange,
    onBlur = props.onBlur,
    value = props.value,
    children = props.children,
    rowClass = props.rowClass,
    format = props.format,
    returnFormat = props.returnFormat,
    errors = props.errors,
    disabled = props.disabled,
    readOnly = props.readOnly,
    delay = props.delay,
    warning = props.warning,
    info = props.info,
    type = props.type,
    _props$onValueChange = props.onValueChange,
    onValueChange = _props$onValueChange === void 0 ? function (event, callback) {
      return callback(event);
    } : _props$onValueChange,
    allowEmptyFormatting = props.allowEmptyFormatting,
    isAllowed = props.isAllowed,
    labelClass = props.labelClass,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? '' : _props$mask,
    _props$inputClass = props.inputClass,
    inputClass = _props$inputClass === void 0 ? 'form-element' : _props$inputClass,
    _props$errorClass = props.errorClass,
    errorClass = _props$errorClass === void 0 ? 'form-element--has-error' : _props$errorClass;
  var _useState = (0, _react.useState)(value !== null && value !== void 0 ? value : ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var debouncedInputValue = (0, _useDebounce.default)(inputValue, delay !== null && delay !== void 0 ? delay : 500);
  var handleChange = (0, _react.useCallback)(function (values) {
    onValueChange === null || onValueChange === void 0 || onValueChange(values, function (_ref) {
      var floatValue = _ref.floatValue,
        formattedValue = _ref.formattedValue;
      setInputValue(returnFormat === 'formatted' ? formattedValue : floatValue);
    });
  }, [onValueChange, returnFormat]);
  var hasErrors = !!errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : '';
  var inputClassName = hasErrors ? "".concat(inputClass, " ").concat(errorClass) : inputClass;
  (0, _react.useEffect)(function () {
    onChange === null || onChange === void 0 || onChange(debouncedInputValue);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [debouncedInputValue]);
  (0, _react.useEffect)(function () {
    return setInputValue(value !== null && value !== void 0 ? value : '');
  }, [value]);
  return /*#__PURE__*/React.createElement(_FormRow.default, {
    className: rowClass,
    hasErrors: hasErrors
  }, /*#__PURE__*/React.createElement(_Label.default, {
    id: id,
    className: labelClass
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "form-element-unit-wrapper"
  }, /*#__PURE__*/React.createElement(_reactNumberFormat.PatternFormat, {
    onValueChange: handleChange,
    onBlur: onBlur,
    getInputRef: inputRef,
    value: inputValue,
    id: id,
    name: name,
    className: inputClassName,
    placeholder: placeholder,
    type: type,
    mask: mask,
    format: format !== null && format !== void 0 ? format : '',
    disabled: disabled,
    readOnly: readOnly,
    isAllowed: isAllowed,
    allowEmptyFormatting: allowEmptyFormatting
  }), unitLabel ? /*#__PURE__*/React.createElement("span", {
    className: "form-element__unit"
  }, unitLabel) : null), /*#__PURE__*/React.createElement(_FormHint.default, {
    error: errorMessage,
    warning: warning,
    info: info
  }));
}
function PatternNumberInput(props, ref) {
  return /*#__PURE__*/React.createElement(_reactHookForm.Controller, _extends({}, props, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        _onBlur = _ref2$field.onBlur,
        value = _ref2$field.value;
      return /*#__PURE__*/React.createElement(PatternNumberInputComponent, _extends({
        inputRef: ref !== null && ref !== void 0 ? ref : null
      }, props, {
        onChange: function onChange(payload) {
          _onChange(payload);
          if (typeof props.onChange === 'function' && payload) {
            props.onChange(payload);
          }
        },
        onBlur: function onBlur(payload) {
          _onBlur();
          if (typeof props.onBlur === 'function' && payload) {
            props === null || props === void 0 || props.onBlur(payload);
          }
        },
        value: value
      }));
    }
  }));
}
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(PatternNumberInput);